import { NgModule } from '@angular/core';
import { CorporateLicenseComponent } from './corporate-license.component';
import { AddonModule } from 'src/app/shared/modules/addon/addon.module';
import { LicenseModule } from 'src/app/shared/modules/license/license.module';
import { CommonModule } from '@angular/common';
import { CorporateLicenseRoutingModule } from './corporate-license.routing.module';
import { BranchLicenseConfirmComponent } from './branch-license-confirm/branch-license-confirm.component';
import { MessageDisplayModule } from 'src/app/shared/validation-messages-display/message-display.module';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
    imports: [
        AddonModule,
        LicenseModule,
        CommonModule,
        MessageDisplayModule,
        MatDialogModule,
        CorporateLicenseRoutingModule
    ],
    declarations: [CorporateLicenseComponent, BranchLicenseConfirmComponent],
    exports: [CorporateLicenseComponent]
})
export class CorporateLicenseModule {
}